export enum ESelectedGamesCardLayoutsType {
  basic = '0',
  advanced = '1'
}

export enum ESelectedGamesCoverMode {
  default = 0,
  cover = 1
}
export enum ESliderType {
  titleWithArrows,
  dots,
  horizontalScroll
}
export enum ESliderDefaultType {
  arrows = 0,
  titleWithArrows = 1
}

export enum EGamePerView {
  oneGame,
  oneAndHalf
}

export enum EMobileCustomSettings {
  off,
  on
}

export type TSelectedGamesConfigs = {
  gameIds: number[];
  gamesPerView: number;
  imgPath: Record<number, string | null>;
  layoutType: number | string;
  cardLayoutsType?: ESelectedGamesCardLayoutsType; // 0, 1 / create enum => ete es mek a nor nerqevi cover mode-in naym enq
  coverMode?: ESelectedGamesCoverMode; // 0, 1 / enum
  aspectRatio?: `${number}`;
  limit: number;
  orderBy: number;
  showTitle?: boolean;
  showGamesAfterSuspension: number;
  selectedSportAutoSlider: number | string;
  selectedSportAutoSliderTime: number;
  oddBorderColor?: string;
  oddsBgColor?: string;
  oddTextColor?: string;
  infoTextColor?: string;
  layerColor?: string;
  moduleId?: number;
  oddBorderColorDark?: string;
  oddsBgColorDark?: string;
  oddTextColorDark?: string;
  infoTextColorDark?: string;
  oddsSelectedColorDark?: string;
  selectedOddBgColorDark?: string;
  selectedOddBorderColorDark?: string;
  oddsSelectedColor?: string;
  selectedOddBgColor?: string;
  selectedOddBorderColor?: string;
  layerColorDark?: string;
  sliderType?: number;
  mobileCustomSettings?: EMobileCustomSettings;
  gamePerViewForMobile?: EGamePerView;
  sliderTypeForMobile?: ESliderType;
};

export type TSelectedGamesProps = {
  configs: TSelectedGamesConfigs;
};
